import React, {FC, PropsWithChildren} from 'react';

import {ClickEventHandler} from '../../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {Button} from '../../../../../../../libs/shared/ui/src/components/buttons/button';
import {IconName} from '../../../../../../../libs/shared/ui/src/components/icon/icon';
import {VisualSizesEnum} from '../../../../../../../libs/shared/ui/src/styles/commonStyles';

/*
 * Props.
 */

interface AiTagSuggestionBannerButtonProps {
  onClick?: ClickEventHandler;
  leftIcon?: IconName;
  leftIconColor?: string;
  isDisabled?: boolean;
}

/*
 * Component.
 */

export const AiTagSuggestionBannerButton: FC<PropsWithChildren<AiTagSuggestionBannerButtonProps>> = (
  props,
) => {
  const {onClick, leftIcon, leftIconColor, isDisabled, children} = props;

  return (
    <Button
      size={VisualSizesEnum.SMALL}
      leftIcon={leftIcon}
      leftIconColor={leftIconColor}
      isDisabled={isDisabled}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};
